export interface AppConfig {
  API_BASE_URL: string
  HIDE_DRAFT_CONTROLS?: boolean
  LANGUAGE_SWITCH_ENABLED?: boolean
  EASTEREGGS_ENABLED?: boolean
  GUIDED_TOUR_ENABLED?: boolean
}

// nginx falls back to index.html for unknown paths, so a missing config.json
// resolves with HTTP 200 + text/html rather than a 404 - both cases must be
// treated as "config missing", not just a failed request.
async function loadConfig(): Promise<AppConfig> {
  const response = await fetch('/config.json')
  const contentType = response.headers.get('content-type') ?? ''
  if (!response.ok || !contentType.includes('application/json')) {
    throw new Error(
      `/config.json antwortete mit Status ${response.status} (Content-Type: ${contentType || 'unbekannt'})`,
    )
  }

  const data = await response.json()
  if (typeof data.API_BASE_URL !== 'string' || data.API_BASE_URL === '') {
    throw new Error('/config.json enthält kein gültiges Feld "API_BASE_URL"')
  }

  return data as AppConfig
}

function showConfigError(error: unknown): void {
  const target = document.getElementById('app')
  if (!target) return

  target.innerHTML = `
    <div style="max-width: 34rem; margin: 4rem auto; padding: 1.5rem 2rem; border: 1px solid #cc0f35; border-radius: 6px; background: #feecf0; font-family: system-ui, sans-serif; color: #333; line-height: 1.5;">
      <h1 style="margin: 0 0 0.75rem; font-size: 1.25rem; color: #cc0f35;">Konfiguration fehlt</h1>
      <p style="margin: 0 0 0.75rem;">
        Die Datei <code>config.json</code> konnte nicht geladen werden. Beim Start über Docker muss sie als
        Volume eingebunden werden (siehe README, Abschnitt „Docker"). Bitte prüfen Sie das Compose-Setup
        und laden Sie die Seite danach neu.
      </p>
      <pre id="config-error-detail" style="margin: 0; padding: 0.75rem; background: #fddde3; border-radius: 4px; font-size: 0.85rem; overflow-x: auto; white-space: pre-wrap;"></pre>
    </div>
  `

  const detail = target.querySelector('#config-error-detail')
  if (detail) {
    detail.textContent = error instanceof Error ? error.message : String(error)
  }
}

export const config: AppConfig = await loadConfig().catch((error: unknown) => {
  showConfigError(error)
  throw error
})
